var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 26.5C24.25 26.5 24.5 26.2812 24.5 26V17H22C21.4375 17 21 16.5625 21 16V13.5H16C15.7188 13.5 15.5 13.75 15.5 14V26C15.5 26.2812 15.7188 26.5 16 26.5H24ZM14 14C14 12.9062 14.875 12 16 12H21.1562C21.6875 12 22.1875 12.2188 22.5625 12.5938L25.4062 15.4375C25.7812 15.8125 26 16.3125 26 16.8438V26C26 27.125 25.0938 28 24 28H16C14.875 28 14 27.125 14 26V14Z",
    fill: "#C1F553"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.ce28cb2f205bb251aa7f8f5597b5ef77.svg";
export { ForwardRef as ReactComponent };